import { TooltipProps } from '@mustmove/recharts';
import React, { useEffect, useState } from 'react';
import FeedCenterStatisticsFeedWritingPercentIcon from './Icon/FeedCenterStatisticsFeedWritingPercentIcon';
import FeedCenterStatisticsGoodPercent from './Icon/FeedCenterStatisticsGoodPercentIcon';
import FeedCenterStatisticsReregister from './Icon/FeedCenterStatisticsReregister';
import { Col, Row } from '../../lib/utils';
import { LightText, RegularText } from '../../lib/Text';

type Props = {
    active?: boolean;
    payload?: any[];
    coordinate: { x: number; y: number };
    mouseYRef?: any;
    isMouseYRef?: boolean;
};

export const CustomTooltip = ({ active, payload, coordinate, mouseYRef, isMouseYRef = true }: Props) => {
    if (!active) return null;

    const monthString = (payload && payload[0]?.payload.monthString) || '';
    const type = (payload && payload[0]?.name) || '';
    const title =
        type === 'centerReportWriteRate' || type === 'reportWriteRate'
            ? '일지작성률'
            : type === 'centerSatisfactionRate' || type === 'satisfactionRate'
            ? '만족도 지수'
            : type === 'centerReRegistrationSuccessRate' || type === 'reRegistrationSuccessRate'
            ? '재등록 성공률'
            : type === 'centerReRegistrationRate' || type === 'reRegistrationRate'
            ? '재등록 회원 비중'
            : '재등록률';

    const IconComponent =
        type === 'centerReportWriteRate' || type === 'reportWriteRate'
            ? FeedCenterStatisticsFeedWritingPercentIcon
            : type === 'centerSatisfactionRate' || type === 'satisfactionRate'
            ? FeedCenterStatisticsGoodPercent
            : FeedCenterStatisticsReregister;

    const value = (payload && payload[0]?.value) ?? null;
    const valueText = value === null ? '-' : `${value.toFixed(0)}%`;

    // const tooltipHeight = 150; // 예측되는 높이
    const tooltipWidth = 120;
    const tooltipHeight = 100;

    return !isMouseYRef ? (
        <div
            className=" absolute bg-[#32373F] w-[100px]  rounded-[4px] p-[6px] flex flex-col justify-between"
            style={{ left: coordinate.x, top: coordinate.y }}
        >
            <LightText fontSize={12} lineHeight={16} color={'white'}>
                {title}
            </LightText>
            <Col className="w-full h-[1px] bg-[#989B9F] my-[6px]" />
            <Row className="w-full justify-between items-center">
                <Row className="items-center">
                    <IconComponent width={13} height={13} iconSize={7} mr={4} />
                    <LightText fontSize={12} lineHeight={16} color={'white'}>
                        {monthString}
                    </LightText>
                </Row>
                <LightText fontSize={12} lineHeight={16} color={'white'}>
                    {valueText}
                </LightText>
            </Row>
        </div>
    ) : (
        <div
            className="absolute bg-[#32373F] rounded-[4px] p-[6px] flex flex-col justify-between"
            style={{
                left: coordinate.x - tooltipWidth / 2,
                top: mouseYRef - tooltipHeight,
                width: tooltipWidth,
            }}
        >
            <LightText fontSize={12} lineHeight={16} color={'white'}>
                {title}
            </LightText>
            <Col className="w-full h-[1px] bg-[#989B9F] my-[6px]" />
            <Row className="w-full justify-between items-center">
                <Row className="items-center">
                    <IconComponent width={13} height={13} iconSize={7} mr={4} />
                    <LightText fontSize={12} lineHeight={16} color={'white'}>
                        {monthString}
                    </LightText>
                </Row>
                <LightText fontSize={12} lineHeight={16} color={'white'}>
                    {valueText}
                </LightText>
            </Row>
        </div>
    );
};
